import { render, staticRenderFns } from "./AttributeItem.vue?vue&type=template&id=42817530&scoped=true&"
import script from "./AttributeItem.vue?vue&type=script&lang=js&"
export * from "./AttributeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42817530",
  null
  
)

export default component.exports